import { isOfType } from '../../../../ts-utils';
import { showToast } from '../effects/show-toast-action';
export const REPORT_COMMENT_SUCCESS = 'REPORT_COMMENT_SUCCESS';
export const REPORT_COMMENT_FAILURE = 'REPORT_COMMENT_FAILURE';
export const reportCommentSuccess = (payload) => ({
    type: REPORT_COMMENT_SUCCESS,
    payload,
});
export const reportCommentFailure = (payload) => ({
    type: REPORT_COMMENT_FAILURE,
    payload,
});
export const reportCommentWithReason = ({ resourceId, commentId, reason, details, }) => async (dispatch, getState, { commentsService }) => {
    const resourceState = getState().comments[resourceId];
    if (resourceState?.type !== 'READY') {
        return;
    }
    const result = await commentsService.reportCommentWithReason({
        commentId,
        reason,
        details,
    });
    result.type === 'SUCCESS'
        ? [
            reportCommentSuccess({ resourceId, commentId }),
            showToast({
                resourceId,
                skin: 'success',
                message: {
                    type: 'TRANSLATION',
                    key: 'toast.report-comment-success',
                },
            }),
        ].map(dispatch)
        : [
            reportCommentFailure({
                resourceId,
                commentId,
            }),
            showToast({
                resourceId,
                skin: 'error',
                message: { type: 'TRANSLATION', key: 'toast.report-comment-failure' },
            }),
        ].map(dispatch);
};
export const isReportCommentAction = isOfType([REPORT_COMMENT_SUCCESS, REPORT_COMMENT_FAILURE]);
//# sourceMappingURL=report-with-reason-actions.js.map